import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../axiosInstance.js';

export const SaveQuizFromApiSlice = createAsyncThunk("savingQuiz",async ({papername,paperId,isTrending}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`savingQuiz/${paperId}`,{
        papername,
        isTrending
      }); 
      console.log(response)
        return response.data;
     
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

export const ListingQuizFromApiSlice = createAsyncThunk("listingQuizesApi",async ({status,params}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`listingQuizesApi/${status}?${params}`);
      console.log(response)
        return response.data;
     
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

const QuizManagementByApiSlice = createSlice({
  name: 'Quiz By Api',
  initialState: {
    AllQuiz: [],
    FetchedQuiz:[],
    EditQuiz:[],
    UpdateStatusQuiz:[],
    pageNumber:{
      pendingQuiz:1,
      publishedQuiz:1,
      rejectedQuiz:1,
    },
    loading: false,
    error: null,
    validationErrors: [],
  },

  reducers: {
   handleHoldPage: (state, action) => {
  const { field, page } = action.payload;
  console.log(field, page);

  if (!state.pageNumber) {
    state.pageNumber = {};
  }

  state.pageNumber[field] = page;
}
  },
  extraReducers: (builder) => {

    const handlePendingState = (state,action) => {
      state.loading = true;
      state.error = null; 
      state.validationErrors = []; 
    }
    const handleRejectState = (state, action) => {
      state.loading = false;
      state.error = action.payload?.message || "An error occurred";
      state.validationErrors = action.payload?.errors || []; 
      // toast.error(state.error);
    }

    builder
      .addCase(SaveQuizFromApiSlice.pending,handlePendingState)
      .addCase(SaveQuizFromApiSlice.fulfilled, (state, action) => {
        state.FetchedQuiz = action.payload.data; 
        state.loading = false;
        // toast.success("Logged Successfully!"); 
      })
      .addCase(SaveQuizFromApiSlice.rejected,handleRejectState)
     
      .addCase(ListingQuizFromApiSlice.pending,handlePendingState)
      .addCase(ListingQuizFromApiSlice.fulfilled, (state, action) => {
        state.AllQuiz = action.payload.data; 
        state.loading = false;
        // toast.success("Logged Successfully!"); 
      })
      .addCase(ListingQuizFromApiSlice.rejected,handleRejectState)
  },
});

export const {handleHoldPage} = QuizManagementByApiSlice.actions

export default QuizManagementByApiSlice.reducer;
